// src/components/Login.js
import React, { useState } from 'react';
import axios from 'axios';
import {
  Form,
  Button,
  Alert,
  Container,
  InputGroup,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { saveAuth } from '../services/auth';

const Login = () => {
  const [credenciales, setCredenciales] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredenciales({ ...credenciales, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const { data } = await axios.post(
        'https://api.sevicol.com.uy/api/auth/login',
        credenciales
      );
      // data = { token, user: { id, username, role } }
      saveAuth(data.token, data.user);

      // Redirección por rol:
      const r = data.user.role;
      if (r === 'admin' || r === 'view') {
        navigate('/admin/postulantes', { replace: true });
      } else if (r === 'dev') {
        navigate('/admin/home', { replace: true });
      } else {
        navigate('/admin', { replace: true });
      }
    } catch (err) {
      setError(err?.response?.data?.error || 'Credenciales inválidas');
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: 560 }}>
      <h2 className="mb-4">Acceso Administrador</h2>
      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Usuario</Form.Label>
          <Form.Control
            type="text"
            name="username"
            onChange={handleChange}
            value={credenciales.username}
            required
          />
        </Form.Group>

       <Form.Group className="mb-3">
          <Form.Label>Contraseña</Form.Label>
          <div className="input-password-wrapper">
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              name="password"
              onChange={handleChange}
              value={credenciales.password}
              required
            />
            <i
              className={`toggle-eye bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
              onClick={() => setShowPassword(v => !v)}
            ></i>
          </div>
        </Form.Group>

        <Button type="submit" className="w-100">
          Ingresar
        </Button>
      </Form>
    </Container>
  );
};

export default Login;



